import React from 'react';
import PropTypes from 'prop-types';
import TextInput from "./";
import { INVALID_DOMAINS } from '../../../../helpers/Constants';

export default class EmailTextInput extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: props.value.trim()
        };

        this.handleChange = this.handleChange.bind(this);
        this.onBlur = this.onBlur.bind(this);
    }

    handleChange(event) {
       const val = event.target.value;
        // fake an event object
        this.setState({
            warning: null,
            value: val,
        }, () => {
            this.props.onChange({
                target: {
                    name: this.props.name,
                    value: val,
                    type: 'text',
                }
            });
        });
    }

    validateEmail(email) {

        if (!email) {
            return null;
        }

        const wildcardMatchUrl = function(str, rule) {
            return new RegExp("^" + rule.replace(/[.?+^$[\]\\(){}|-]/g, "\\$&").split("*").join(".*") + "$").test(str);
        };

        let warning = null;
        const domain = email.split('@');
        if (domain.length < 2) {
            return 'Looks like the email address is missing something';
        }
        let actual = INVALID_DOMAINS[domain[1]];

        if (!actual){
            // Try wildcard match
            for (const key in INVALID_DOMAINS) {
                if (key.indexOf('*') > -1 && wildcardMatchUrl(domain[1], key)) {
                    actual = INVALID_DOMAINS[key];
                    break;
                }
            }
        }

        if (!actual){
            return null;
        } else if (actual === 'INVALID') {
            return 'Are you sure the domain is correct?';
        } else {
            return `Did you mean '${domain[0]}@${actual}' ?`;
        }
        
        return warning;
    }

    onBlur(event, email) {
        const warning = this.validateEmail(email);
        this.setState({
            warning
        }, function() {
            if (this.props.onBlur) {
                this.props.onBlur(event, email);
            }
        });
    }

    render() {

        const { warning, ...otherProps } = this.props;

        // const newWarning = this.validateEmail(this.props.value);
        const val = this.props.disabled ? '' : this.state.value;

        return (
            <TextInput
                {...otherProps}
                onChange={this.handleChange}
                warning={warning || this.state.warning}
                onBlur={(event) => this.onBlur(event, this.props.value)}
                value={val}
            />
        );
    } 
}

EmailTextInput.propTypes = {
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.string,
    error: PropTypes.string,
    warning: PropTypes.any,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
};
